module.exports = __webpack_public_path__ + "static/media/4d1d0d0d-9ea6-4117-901f-8b32ca1ab936.7ffc334a.woff";